/**
 * Funkcinės Terapijos Centras — Skausmo poveikio vertinimas
 * "Kiek skausmas veikia jūsų kasdienybę?"
 * Clinical-grade pain impact assessment (NDI/ODI adapted)
 *
 *   Place <div id="ftc-pain-impact"></div> in your page HTML.
 *   Load via Liquid: {{ 'ftc-impact.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var scriptTag = document.currentScript;
  var KLAVIYO_COMPANY_ID = scriptTag.getAttribute('data-klaviyo-id') || 'WGyTS6';
  var KLAVIYO_LIST_ID = scriptTag.getAttribute('data-list-id') || 'UPpkZH';
  var BOOKING_URL = scriptTag.getAttribute('data-booking-url') || 'https://funkcinesterapijoscentras.lt/pages/registracija';

  // ── Inject CSS ──
  var css = document.createElement('style');
  css.textContent = '' +
    '.ftcp *,.ftcp *::before,.ftcp *::after{box-sizing:border-box;margin:0;padding:0}' +
    '.ftcp{font-family:"Segoe UI",system-ui,-apple-system,sans-serif;max-width:680px;margin:40px auto;border-radius:20px;overflow:hidden;box-shadow:0 12px 48px rgba(30,126,186,.15),0 2px 8px rgba(0,0,0,.06);background:#fff}' +

    /* Header — premium gradient */
    '.ftcp-header{background:linear-gradient(135deg,#0f4c75 0%,#1E7EBA 50%,#1a8a9e 100%);padding:40px 32px 32px;text-align:center;position:relative;overflow:hidden}' +
    '.ftcp-header::before{content:"";position:absolute;top:-60%;right:-25%;width:400px;height:400px;background:radial-gradient(circle,rgba(0,190,195,.15) 0%,transparent 70%);border-radius:50%}' +
    '.ftcp-header::after{content:"";position:absolute;bottom:-40%;left:-15%;width:300px;height:300px;background:radial-gradient(circle,rgba(255,255,255,.06) 0%,transparent 70%);border-radius:50%}' +
    '.ftcp-header h2{color:#fff;font-size:24px;font-weight:700;margin-bottom:8px;position:relative;z-index:1;line-height:1.3}' +
    '.ftcp-header p{color:rgba(255,255,255,.8);font-size:14px;position:relative;z-index:1;line-height:1.5;max-width:440px;margin:0 auto}' +
    '.ftcp-badge{display:inline-block;background:rgba(0,190,195,.3);color:#fff;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1.5px;padding:5px 16px;border-radius:20px;margin-bottom:14px;position:relative;z-index:1;backdrop-filter:blur(4px)}' +

    /* Progress */
    '.ftcp-progress-wrap{padding:0 32px;margin-top:-6px;position:relative;z-index:2}' +
    '.ftcp-progress-bar{height:6px;background:#e8f0f5;border-radius:3px;overflow:hidden;margin-top:16px}' +
    '.ftcp-progress-fill{height:100%;background:linear-gradient(90deg,#00BEC3,#1E7EBA);border-radius:3px;transition:width .6s cubic-bezier(.4,0,.2,1);width:0%}' +
    '.ftcp-step-count{text-align:center;font-size:12px;color:#7a9bb5;margin-top:8px;font-weight:500}' +

    /* Body */
    '.ftcp-body{padding:28px 32px 32px;min-height:360px;position:relative}' +

    /* Intro */
    '.ftcp-intro{text-align:center}' +
    '.ftcp-intro-icon{width:80px;height:80px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px;box-shadow:0 4px 16px rgba(0,190,195,.15)}' +
    '.ftcp-intro-icon svg{width:40px;height:40px;color:#1E7EBA}' +
    '.ftcp-intro h3{font-size:20px;color:#1a2e3d;margin-bottom:12px;font-weight:700}' +
    '.ftcp-intro p{font-size:14px;color:#5a7080;line-height:1.6;margin-bottom:8px}' +
    '.ftcp-intro-features{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:20px auto;max-width:420px}' +
    '.ftcp-feature{display:flex;align-items:center;gap:10px;padding:10px 14px;background:#f6f9fb;border-radius:10px;font-size:13px;color:#3d5a6e}' +
    '.ftcp-feature-icon{width:28px;height:28px;min-width:28px;background:#00BEC3;border-radius:8px;display:flex;align-items:center;justify-content:center}' +
    '.ftcp-feature-icon svg{width:14px;height:14px;color:#fff}' +

    /* Slides */
    '.ftcp-slide{display:none;animation:ftcpFadeIn .4s ease}' +
    '.ftcp-slide.active{display:block}' +
    '@keyframes ftcpFadeIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}' +

    /* Questions */
    '.ftcp-q-category{display:inline-block;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1.2px;padding:4px 12px;border-radius:6px;margin-bottom:10px}' +
    '.ftcp-q-category.work{background:#e8f0fe;color:#2c5282}.ftcp-q-category.sleep{background:#ede8fe;color:#5b3ebd}.ftcp-q-category.hobby{background:#e8f8ef;color:#1e8449}.ftcp-q-category.mood{background:#fef3e2;color:#b45309}.ftcp-q-category.daily{background:#fce8e6;color:#c0392b}.ftcp-q-category.pain{background:#e6f5f6;color:#0e7c86}' +
    '.ftcp-question-text{font-size:18px;color:#1a2e3d;font-weight:600;margin-bottom:6px;line-height:1.4}' +
    '.ftcp-question-hint{font-size:13px;color:#7a9bb5;margin-bottom:24px;line-height:1.5}' +
    '.ftcp-options{display:flex;flex-direction:column;gap:8px;margin-top:4px}' +
    '.ftcp-option{display:flex;align-items:center;gap:14px;padding:14px 18px;border:2px solid #e8f0f5;border-radius:12px;cursor:pointer;transition:all .25s ease;background:#fff;position:relative}' +
    '.ftcp-option:hover{border-color:#b8dce8;background:#f6fbfd;transform:translateX(4px)}' +
    '.ftcp-option.selected{border-color:#00BEC3;background:#e6f9fa;transform:translateX(4px)}' +
    '.ftcp-option-score{width:28px;height:28px;min-width:28px;border-radius:50%;border:2px solid #d8e4ec;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#a0b0bb;transition:all .25s ease}' +
    '.ftcp-option.selected .ftcp-option-score{border-color:#00BEC3;background:#00BEC3;color:#fff}' +
    '.ftcp-option-text{font-size:14px;color:#2a4050;font-weight:500;line-height:1.4}' +

    /* Buttons */
    '.ftcp-buttons{display:flex;justify-content:space-between;align-items:center;margin-top:28px;gap:12px}' +
    '.ftcp-btn{padding:12px 28px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;border:none;transition:all .3s ease;display:inline-flex;align-items:center;gap:6px}' +
    '.ftcp-btn-primary{background:linear-gradient(135deg,#00BEC3,#00a8ad);color:#fff;box-shadow:0 4px 14px rgba(0,190,195,.3)}' +
    '.ftcp-btn-primary:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcp-btn-secondary{background:transparent;color:#7a9bb5;border:2px solid #e0e8ed}' +
    '.ftcp-btn-secondary:hover{border-color:#b8d0dd;color:#5a7a90}' +
    '.ftcp-btn-large{width:100%;justify-content:center;padding:16px 28px;font-size:16px;border-radius:12px}' +
    '.ftcp-btn svg{width:16px;height:16px}' +

    /* Email gate */
    '.ftcp-email-gate{text-align:center}' +
    '.ftcp-email-gate h3{font-size:20px;color:#1a2e3d;margin-bottom:8px;font-weight:700}' +
    '.ftcp-email-gate p{font-size:14px;color:#5a7080;margin-bottom:20px;line-height:1.5}' +
    '.ftcp-email-icon{width:68px;height:68px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;box-shadow:0 4px 16px rgba(0,190,195,.12)}' +
    '.ftcp-email-icon svg{width:32px;height:32px;color:#1E7EBA}' +
    '.ftcp-input-wrap{position:relative;margin-bottom:12px}' +
    '.ftcp-input{width:100%;padding:16px 18px;border:2px solid #e0e8ed;border-radius:12px;font-size:15px;font-family:inherit;color:#2a4050;outline:none;transition:border-color .3s ease;background:#fff}' +
    '.ftcp-input:focus{border-color:#00BEC3;box-shadow:0 0 0 4px rgba(0,190,195,.1)}' +
    '.ftcp-input::placeholder{color:#a8bcc8}' +
    '.ftcp-email-note{font-size:11px;color:#a0b0bb;margin-top:8px}' +
    '.ftcp-email-error{color:#e05555;font-size:12px;margin-top:4px;display:none}' +

    /* Results — premium layout */
    '.ftcp-results{text-align:center}' +

    /* Animated gauge */
    '.ftcp-gauge-wrap{position:relative;width:180px;margin:0 auto 24px}' +
    '.ftcp-gauge-bg{width:180px;height:180px;border-radius:50%;position:relative}' +
    '.ftcp-gauge-svg{width:180px;height:180px;transform:rotate(-90deg)}' +
    '.ftcp-gauge-track{fill:none;stroke:#eef2f5;stroke-width:10}' +
    '.ftcp-gauge-fill{fill:none;stroke-width:10;stroke-linecap:round;transition:stroke-dashoffset 1.5s cubic-bezier(.4,0,.2,1),stroke 1s ease}' +
    '.ftcp-gauge-center{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}' +
    '.ftcp-gauge-score{font-size:42px;font-weight:800;line-height:1;letter-spacing:-1px}' +
    '.ftcp-gauge-max{font-size:13px;color:#7a9bb5;font-weight:500;margin-top:2px}' +
    '.ftcp-gauge-label{display:inline-block;padding:6px 18px;border-radius:20px;font-size:13px;font-weight:700;margin-top:4px;margin-bottom:20px;letter-spacing:0.5px}' +

    /* Severity colors */
    '.ftcp-minimal .ftcp-gauge-score{color:#27ae60}.ftcp-minimal .ftcp-gauge-label{background:#eafaf1;color:#1e8449}.ftcp-minimal .ftcp-gauge-fill{stroke:#27ae60}' +
    '.ftcp-moderate .ftcp-gauge-score{color:#d4a017}.ftcp-moderate .ftcp-gauge-label{background:#fef9e7;color:#9a7b0a}.ftcp-moderate .ftcp-gauge-fill{stroke:#d4a017}' +
    '.ftcp-significant .ftcp-gauge-score{color:#e67e22}.ftcp-significant .ftcp-gauge-label{background:#fef4e6;color:#b45309}.ftcp-significant .ftcp-gauge-fill{stroke:#e67e22}' +
    '.ftcp-severe .ftcp-gauge-score{color:#c0392b}.ftcp-severe .ftcp-gauge-label{background:#fce8e6;color:#922b21}.ftcp-severe .ftcp-gauge-fill{stroke:#c0392b}' +

    '.ftcp-result-text{font-size:15px;color:#2a4050;line-height:1.6;margin-bottom:24px;max-width:500px;margin-left:auto;margin-right:auto}' +

    /* Category breakdown bars */
    '.ftcp-breakdown{text-align:left;margin-bottom:24px;background:#f8fafb;border-radius:14px;padding:20px 22px}' +
    '.ftcp-breakdown h4{font-size:14px;font-weight:600;color:#1a2e3d;margin-bottom:14px;text-align:center}' +
    '.ftcp-bar-row{display:flex;align-items:center;gap:12px;margin-bottom:10px}' +
    '.ftcp-bar-row:last-child{margin-bottom:0}' +
    '.ftcp-bar-label{width:100px;min-width:100px;font-size:12px;font-weight:600;color:#5a7080;text-align:right}' +
    '.ftcp-bar-track{flex:1;height:14px;background:#e8f0f5 !important;border-radius:7px;overflow:hidden;position:relative}' +
    '.ftcp .ftcp-bar-fill,span.ftcp-bar-fill{position:absolute !important;top:0 !important;left:0 !important;height:14px !important;min-height:14px !important;border-radius:7px !important;display:block !important}' +
    '.ftcp-bar-val{width:28px;min-width:28px;font-size:12px;font-weight:700;color:#5a7080}' +

    /* Detail box */
    '.ftcp-result-detail{background:#f6f9fb;border-radius:14px;padding:18px 22px;margin-bottom:24px;text-align:left;border:1px solid #eef2f5}' +
    '.ftcp-result-detail h4{font-size:15px;font-weight:600;color:#1a2e3d;margin-bottom:10px}' +
    '.ftcp-result-detail p{font-size:13px;color:#5a7080;line-height:1.6}' +

    /* Promo */
    '.ftcp-promo{border:2px dashed #00BEC3;border-radius:14px;padding:18px 22px;margin-bottom:20px;text-align:center;background:linear-gradient(135deg,#f0fafb,#e6f5f6)}' +
    '.ftcp-promo-label{font-size:13px;color:#5a7080;margin-bottom:4px}' +
    '.ftcp-promo-value{font-size:28px;font-weight:800;color:#0e7c86;letter-spacing:1px}' +
    '.ftcp-promo-code{display:inline-block;margin-top:8px;background:#0e7c86;color:#fff;font-weight:700;font-size:14px;padding:5px 16px;border-radius:8px;letter-spacing:1.5px}' +
    '.ftcp-promo-note{font-size:13px;color:#2a4050;margin-top:6px}' +

    /* CTA */
    '.ftcp-result-cta,.ftcp-result-cta:visited,.ftcp-result-cta:active,.ftcp-result-cta:hover{background:linear-gradient(135deg,#00BEC3,#00a8ad);color:#fff !important;padding:16px 36px;border-radius:12px;font-size:16px;font-weight:700;cursor:pointer;border:none;display:inline-flex;align-items:center;gap:10px;transition:all .3s ease;box-shadow:0 6px 20px rgba(0,190,195,.3);text-decoration:none !important}' +
    '.ftcp-result-cta:hover{transform:translateY(-2px);box-shadow:0 8px 28px rgba(0,190,195,.4)}' +
    '.ftcp-result-cta svg{width:18px;height:18px}' +
    '.ftcp-disclaimer{font-size:11px;color:#a0b0bb;margin-top:18px;line-height:1.4;padding-top:14px;border-top:1px solid #eef2f5}' +

    /* Responsive */
    '@media(max-width:480px){.ftcp{margin:16px 8px;border-radius:14px}.ftcp-header{padding:28px 20px 24px}.ftcp-header h2{font-size:20px}.ftcp-body{padding:22px 20px 26px}.ftcp-progress-wrap{padding:0 20px}.ftcp-intro-features{grid-template-columns:1fr}.ftcp-bar-label{width:72px;min-width:72px;font-size:11px}.ftcp-buttons{flex-direction:column-reverse}.ftcp-btn{width:100%;justify-content:center}.ftcp-gauge-wrap{width:150px;height:150px}.ftcp-gauge-bg,.ftcp-gauge-svg{width:150px;height:150px}.ftcp-gauge-score{font-size:34px}}';
  document.head.appendChild(css);

  // ── SVG helpers ──
  var svgArrowR = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>';
  var svgArrowL = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12"/></svg>';
  var svgCheck  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/></svg>';
  var svgCheckS = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
  var svgMail   = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>';
  var svgCal    = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>';
  var svgPulse  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/></svg>';
  var svgClock  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>';
  var svgShield = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>';
  var svgChart  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/></svg>';

  // Category labels & colors for breakdown
  var cats = [
    { key: 'pain',  label: 'Skausmas',   color: '#1E7EBA' },
    { key: 'work',  label: 'Darbas',     color: '#2c5282' },
    { key: 'sleep', label: 'Miegas',     color: '#5b3ebd' },
    { key: 'hobby', label: 'Laisvalaikis', color: '#27ae60' },
    { key: 'mood',  label: 'Nuotaika',   color: '#e67e22' },
    { key: 'daily', label: 'Kasdienybė', color: '#c0392b' }
  ];

  // Gauge circumference (r=75)
  var CIRC = 2 * Math.PI * 75; // ~471.24

  // ── Build HTML ──
  var html = '' +
    '<div class="ftcp-header">' +
      '<div class="ftcp-badge">Klinikinis vertinimas</div>' +
      '<h2>Kiek skausmas veikia j\u016bs\u0173 kasdienybę?</h2>' +
      '<p>Moksliškai pagrįstas skausmo poveikio \u012fvertinimas, pritaikytas pagal tarptautinius standartus.</p>' +
    '</div>' +
    '<div class="ftcp-progress-wrap" id="ftcpProgressWrap" style="display:none;">' +
      '<div class="ftcp-progress-bar"><div class="ftcp-progress-fill" id="ftcpProgressFill"></div></div>' +
      '<div class="ftcp-step-count" id="ftcpStepCount"></div>' +
    '</div>' +
    '<div class="ftcp-body">' +

      /* Intro */
      '<div class="ftcp-slide active" id="ftcpIntro"><div class="ftcp-intro">' +
        '<div class="ftcp-intro-icon">' + svgPulse + '</div>' +
        '<h3>\u012evertinkite skausmo \u012ftak\u0105 savo gyvenimui</h3>' +
        '<p>Atsakykite \u012f 6 klausimus apie skausmo poveik\u012f skirtingoms gyvenimo sritims. Gausite detalią analizę su asmenin\u0117mis rekomendacijomis.</p>' +
        '<div class="ftcp-intro-features">' +
          '<div class="ftcp-feature"><div class="ftcp-feature-icon">' + svgClock + '</div><span>3 minutės</span></div>' +
          '<div class="ftcp-feature"><div class="ftcp-feature-icon">' + svgShield + '</div><span>Konfidencialu</span></div>' +
          '<div class="ftcp-feature"><div class="ftcp-feature-icon">' + svgChart + '</div><span>Detali analizė</span></div>' +
          '<div class="ftcp-feature"><div class="ftcp-feature-icon">' + svgCheckS + '</div><span>Patarimai</span></div>' +
        '</div>' +
        '<button class="ftcp-btn ftcp-btn-primary ftcp-btn-large" id="ftcpStartBtn" style="margin-top:8px">Pradėti vertinimą ' + svgArrowR + '</button>' +
      '</div></div>' +

      /* Q1 — Pain intensity */
      '<div class="ftcp-slide" id="ftcpQ1">' +
        '<div class="ftcp-q-category pain">Skausmo intensyvumas</div>' +
        '<div class="ftcp-question-text">Kaip apibūdintumėte savo skausmą per pastarąją savaitę?</div>' +
        '<div class="ftcp-question-hint">Vertinkite vidutinį skausmo stiprumą.</div>' +
        '<div class="ftcp-options" id="ftcpO1">' +
          '<div class="ftcp-option" data-score="0"><div class="ftcp-option-score">0</div><div class="ftcp-option-text">Skausmo beveik nėra arba jis labai retas</div></div>' +
          '<div class="ftcp-option" data-score="1"><div class="ftcp-option-score">1</div><div class="ftcp-option-text">Lengvas skausmas, kartais nepatogu</div></div>' +
          '<div class="ftcp-option" data-score="2"><div class="ftcp-option-score">2</div><div class="ftcp-option-text">Vidutinis skausmas, jaučiu kasdien</div></div>' +
          '<div class="ftcp-option" data-score="3"><div class="ftcp-option-score">3</div><div class="ftcp-option-text">Stiprus skausmas, apsunkinantis veiklas</div></div>' +
          '<div class="ftcp-option" data-score="4"><div class="ftcp-option-score">4</div><div class="ftcp-option-text">Labai stiprus, beveik nuolatinis skausmas</div></div>' +
        '</div>' +
      '</div>' +

      /* Q2 — Work */
      '<div class="ftcp-slide" id="ftcpQ2">' +
        '<div class="ftcp-q-category work">Darbas ir produktyvumas</div>' +
        '<div class="ftcp-question-text">Kiek skausmas veikia jūsų darbą ar pagrindines pareigas?</div>' +
        '<div class="ftcp-question-hint">Vertinkite poveikį darbo kokybei ir efektyvumui.</div>' +
        '<div class="ftcp-options" id="ftcpO2">' +
          '<div class="ftcp-option" data-score="0"><div class="ftcp-option-score">0</div><div class="ftcp-option-text">Galiu dirbti be jokių apribojimų</div></div>' +
          '<div class="ftcp-option" data-score="1"><div class="ftcp-option-score">1</div><div class="ftcp-option-text">Galiu dirbti, bet kartais jaučiu diskomfortą</div></div>' +
          '<div class="ftcp-option" data-score="2"><div class="ftcp-option-score">2</div><div class="ftcp-option-text">Turiu reguliariai daryti pertraukas dėl skausmo</div></div>' +
          '<div class="ftcp-option" data-score="3"><div class="ftcp-option-score">3</div><div class="ftcp-option-text">Skausmas labai riboja darbo galimybes</div></div>' +
          '<div class="ftcp-option" data-score="4"><div class="ftcp-option-score">4</div><div class="ftcp-option-text">Negaliu normaliai dirbti dėl skausmo</div></div>' +
        '</div>' +
      '</div>' +

      /* Q3 — Sleep */
      '<div class="ftcp-slide" id="ftcpQ3">' +
        '<div class="ftcp-q-category sleep">Miego kokybė</div>' +
        '<div class="ftcp-question-text">Kiek skausmas veikia jūsų miegą?</div>' +
        '<div class="ftcp-question-hint">Vertinkite užmigimą, miego kokybę ir poilsį.</div>' +
        '<div class="ftcp-options" id="ftcpO3">' +
          '<div class="ftcp-option" data-score="0"><div class="ftcp-option-score">0</div><div class="ftcp-option-text">Miegu gerai, skausmas netrukdo</div></div>' +
          '<div class="ftcp-option" data-score="1"><div class="ftcp-option-score">1</div><div class="ftcp-option-text">Kartais sunkiau užmigti dėl diskomforto</div></div>' +
          '<div class="ftcp-option" data-score="2"><div class="ftcp-option-score">2</div><div class="ftcp-option-text">Reguliariai pabundu naktį dėl skausmo</div></div>' +
          '<div class="ftcp-option" data-score="3"><div class="ftcp-option-score">3</div><div class="ftcp-option-text">Miegu prastai, ryte jaučiuosi nepailsėjęs</div></div>' +
          '<div class="ftcp-option" data-score="4"><div class="ftcp-option-score">4</div><div class="ftcp-option-text">Miegas labai sutrikęs, skausmas nuolatinis</div></div>' +
        '</div>' +
      '</div>' +

      /* Q4 — Hobbies */
      '<div class="ftcp-slide" id="ftcpQ4">' +
        '<div class="ftcp-q-category hobby">Laisvalaikis ir hobiai</div>' +
        '<div class="ftcp-question-text">Kiek skausmas riboja jūsų laisvalaikio veiklas?</div>' +
        '<div class="ftcp-question-hint">Sportas, pasivaikščiojimai, pomėgiai, socialinė veikla.</div>' +
        '<div class="ftcp-options" id="ftcpO4">' +
          '<div class="ftcp-option" data-score="0"><div class="ftcp-option-score">0</div><div class="ftcp-option-text">Galiu užsiimti visomis veiklomis be apribojimų</div></div>' +
          '<div class="ftcp-option" data-score="1"><div class="ftcp-option-score">1</div><div class="ftcp-option-text">Galiu užsiimti daugeliu veiklų, kai kurios nepatogios</div></div>' +
          '<div class="ftcp-option" data-score="2"><div class="ftcp-option-score">2</div><div class="ftcp-option-text">Turiu vengti kai kurių veiklų dėl skausmo</div></div>' +
          '<div class="ftcp-option" data-score="3"><div class="ftcp-option-score">3</div><div class="ftcp-option-text">Daugelį veiklų pakeičiau arba atsisakiau</div></div>' +
          '<div class="ftcp-option" data-score="4"><div class="ftcp-option-score">4</div><div class="ftcp-option-text">Negaliu užsiimti beveik jokiomis laisvalaikio veiklomis</div></div>' +
        '</div>' +
      '</div>' +

      /* Q5 — Mood */
      '<div class="ftcp-slide" id="ftcpQ5">' +
        '<div class="ftcp-q-category mood">Emocinė būklė</div>' +
        '<div class="ftcp-question-text">Kaip skausmas veikia jūsų nuotaiką ir emocinę būklę?</div>' +
        '<div class="ftcp-question-hint">Vertinkite bendrą emocinį foną per pastarąjį mėnesį.</div>' +
        '<div class="ftcp-options" id="ftcpO5">' +
          '<div class="ftcp-option" data-score="0"><div class="ftcp-option-score">0</div><div class="ftcp-option-text">Nuotaika gera, skausmas neveikia emocijų</div></div>' +
          '<div class="ftcp-option" data-score="1"><div class="ftcp-option-score">1</div><div class="ftcp-option-text">Kartais jaučiu nusivylimą dėl skausmo</div></div>' +
          '<div class="ftcp-option" data-score="2"><div class="ftcp-option-score">2</div><div class="ftcp-option-text">Skausmas reguliariai gadina nuotaiką</div></div>' +
          '<div class="ftcp-option" data-score="3"><div class="ftcp-option-score">3</div><div class="ftcp-option-text">Jaučiu nuolatinį nerimą ar liūdesį dėl skausmo</div></div>' +
          '<div class="ftcp-option" data-score="4"><div class="ftcp-option-score">4</div><div class="ftcp-option-text">Skausmas labai stipriai veikia emocinę būklę</div></div>' +
        '</div>' +
      '</div>' +

      /* Q6 — Daily tasks */
      '<div class="ftcp-slide" id="ftcpQ6">' +
        '<div class="ftcp-q-category daily">Kasdienės užduotys</div>' +
        '<div class="ftcp-question-text">Kiek skausmas trukdo atlikti paprastas kasdienines užduotis?</div>' +
        '<div class="ftcp-question-hint">Higiena, apsirengimas, vairavimas, apsipirkimas, namų ruoša.</div>' +
        '<div class="ftcp-options" id="ftcpO6">' +
          '<div class="ftcp-option" data-score="0"><div class="ftcp-option-score">0</div><div class="ftcp-option-text">Viską atlieku be sunkumų</div></div>' +
          '<div class="ftcp-option" data-score="1"><div class="ftcp-option-score">1</div><div class="ftcp-option-text">Kai kurios užduotys sukelia nedidelį diskomfortą</div></div>' +
          '<div class="ftcp-option" data-score="2"><div class="ftcp-option-score">2</div><div class="ftcp-option-text">Turiu pritaikyti būdą, kaip atlieku kai kurias užduotis</div></div>' +
          '<div class="ftcp-option" data-score="3"><div class="ftcp-option-score">3</div><div class="ftcp-option-text">Daug užduočių reikalauja pagalbos arba yra labai sunkios</div></div>' +
          '<div class="ftcp-option" data-score="4"><div class="ftcp-option-score">4</div><div class="ftcp-option-text">Man reikia pagalbos daugelyje kasdienių veiklų</div></div>' +
        '</div>' +
      '</div>' +

      /* Email gate */
      '<div class="ftcp-slide" id="ftcpEmail"><div class="ftcp-email-gate">' +
        '<div class="ftcp-email-icon">' + svgMail + '</div>' +
        '<h3>Jūsų analizė paruošta!</h3>' +
        '<p>Įveskite savo el. pa\u0161tą ir gaukite detalią skausmo poveikio analizę su asmeninėmis rekomendacijomis.</p>' +
        '<div class="ftcp-input-wrap"><input type="email" class="ftcp-input" id="ftcpEmailInput" placeholder="jūsų@elpaštas.lt"><div class="ftcp-email-error" id="ftcpEmailError">Įveskite teisingą el. pašto adresą</div></div>' +
        '<button class="ftcp-btn ftcp-btn-primary ftcp-btn-large" id="ftcpEmailBtn">Gauti analizę ' + svgCheck + '</button>' +
        '<div class="ftcp-email-note">Galėsite bet kada atsisakyti naujienlaiškio.</div>' +
      '</div></div>' +

      /* Results */
      '<div class="ftcp-slide" id="ftcpResults"><div class="ftcp-results" id="ftcpResultsInner">' +
        '<div class="ftcp-gauge-wrap" id="ftcpGaugeWrap"><div class="ftcp-gauge-bg">' +
          '<svg class="ftcp-gauge-svg" viewBox="0 0 180 180"><circle class="ftcp-gauge-track" cx="90" cy="90" r="75"/>' +
          '<circle class="ftcp-gauge-fill" id="ftcpGaugeFill" cx="90" cy="90" r="75" stroke-dasharray="' + CIRC.toFixed(1) + '" stroke-dashoffset="' + CIRC.toFixed(1) + '"/></svg>' +
          '<div class="ftcp-gauge-center"><div class="ftcp-gauge-score" id="ftcpScoreNum">0</div><div class="ftcp-gauge-max">iš 24</div></div>' +
        '</div>' +
        '<div class="ftcp-gauge-label" id="ftcpLevelLabel"></div></div>' +
        '<div class="ftcp-result-text" id="ftcpResultText"></div>' +
        '<div class="ftcp-breakdown" id="ftcpBreakdown"><h4>Poveikis pagal sritį</h4></div>' +
        '<div class="ftcp-result-detail" id="ftcpDetail"><h4 id="ftcpDetailTitle"></h4><p id="ftcpDetailText"></p></div>' +
        '<div class="ftcp-promo"><div class="ftcp-promo-label">Pirmai registracijai taikoma nuolaida</div><div class="ftcp-promo-value">-10%</div><div class="ftcp-promo-note">Registracijos formoje \u012fveskite nuolaidos kodą</div><div class="ftcp-promo-code">REGISTRACIJA10</div></div>' +
        '<a class="ftcp-result-cta" href="' + BOOKING_URL + '" target="_blank">Registruotis konsultacijai ' + svgCal + '</a>' +
        '<div class="ftcp-disclaimer">Šis klausimynas yra informacinio pobūdžio ir paremtas tarptautiniu NDI/ODI vertinimo principu. Jis nepakeičia profesionalaus gydytojo konsultacijos.</div>' +
      '</div></div>' +

      /* Nav */
      '<div class="ftcp-buttons" id="ftcpNav" style="display:none;">' +
        '<button class="ftcp-btn ftcp-btn-secondary" id="ftcpBtnBack">' + svgArrowL + ' Atgal</button>' +
        '<button class="ftcp-btn ftcp-btn-primary" id="ftcpBtnNext">Kitas ' + svgArrowR + '</button>' +
      '</div>' +

    '</div>';

  // ── Mount ──
  var target = document.getElementById('ftc-pain-impact');
  if (!target) return;
  var root = document.createElement('div');
  root.className = 'ftcp';
  root.id = 'ftcpChecker';
  root.innerHTML = html;
  target.appendChild(root);

  // ── State ──
  var currentStep = 0;
  var totalSteps = 6;
  var answers = {}; // q1-q6: 0-4

  var nav          = document.getElementById('ftcpNav');
  var progressWrap = document.getElementById('ftcpProgressWrap');
  var backBtn      = document.getElementById('ftcpBtnBack');
  var nextBtn      = document.getElementById('ftcpBtnNext');
  var progressFill = document.getElementById('ftcpProgressFill');
  var stepCount    = document.getElementById('ftcpStepCount');

  // ── Events ──
  document.getElementById('ftcpStartBtn').addEventListener('click', function () {
    currentStep = 1; showStep();
  });
  nextBtn.addEventListener('click', function () {
    /* not used — auto-advance only */
  });
  backBtn.addEventListener('click', function () {
    currentStep = currentStep === 7 ? totalSteps : Math.max(1, currentStep - 1);
    showStep();
  });
  document.getElementById('ftcpEmailBtn').addEventListener('click', submitEmail);

  // Option cards Q1-Q6 (all auto-advance)
  [1, 2, 3, 4, 5, 6].forEach(function (q) {
    document.querySelectorAll('#ftcpO' + q + ' .ftcp-option').forEach(function (el) {
      el.addEventListener('click', function () {
        answers[q] = parseInt(el.getAttribute('data-score'));
        el.parentElement.querySelectorAll('.ftcp-option').forEach(function (s) { s.classList.remove('selected'); });
        el.classList.add('selected');
        setTimeout(function () {
          currentStep = q < totalSteps ? q + 1 : 7; // after Q6 → email gate
          showStep();
        }, 350);
      });
    });
  });

  // ── Functions ──
  function getTotalScore() {
    var total = 0;
    for (var k in answers) total += answers[k];
    return total;
  }

  function getLevel(score) {
    if (score <= 6) return 'minimal';
    if (score <= 12) return 'moderate';
    if (score <= 18) return 'significant';
    return 'severe';
  }

  function submitEmail() {
    var emailInput = document.getElementById('ftcpEmailInput');
    var email = emailInput.value.trim();
    var errorEl = document.getElementById('ftcpEmailError');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.style.display = 'block'; emailInput.style.borderColor = '#e05555'; return;
    }
    errorEl.style.display = 'none'; emailInput.style.borderColor = '#00BEC3';
    sendToKlaviyo(email);
    currentStep = 8; showStep(); computeResults();
  }

  function sendToKlaviyo(email) {
    if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) return;
    var score = getTotalScore();
    var level = getLevel(score);
    var subData = {
      data: { type: 'subscription', attributes: { custom_source: 'Pain Impact Widget',
        profile: { data: { type: 'profile', attributes: { email: email },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(subData)
    }).then(function (r) { console.log('[FTC Impact] subscribe:', r.status); }).catch(function (e) { console.error('[FTC Impact]', e); });
// Also subscribe to combined widget list
subData.data.relationships.list.data.id = 'VfJCJm';
fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(subData)}).then(function(r){console.log('[FTC] combined:',r.status);}).catch(function(e){console.error(e);});
subData.data.relationships.list.data.id = KLAVIYO_LIST_ID;
level = {minimal:'Minimalus poveikis',moderate:'Vidutinis poveikis',significant:'Didelis poveikis',severe:'Labai didelis poveikis'}[level] || level;
    var profileData = {
      data: { type: 'profile', attributes: { email: email, properties: {
        pain_impact_score: score,
        pain_impact_level: level,
        pain_impact_pct: Math.round((score / 24) * 100),
        pain_impact_date: new Date().toISOString()
      } } }
    };
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(profileData)
    }).then(function (r) { console.log('[FTC Impact] profile:', r.status); }).catch(function (e) { console.error('[FTC Impact]', e); });
  }

  function computeResults() {
    var score = getTotalScore();
    var pct = Math.round((score / 24) * 100);
    var level = getLevel(score);

    // Apply severity class
    var inner = document.getElementById('ftcpResultsInner');
    inner.className = 'ftcp-results ftcp-' + level;

    // Animate gauge
    var gaugeFill = document.getElementById('ftcpGaugeFill');
    var offset = CIRC - (CIRC * (pct / 100));
    setTimeout(function () { gaugeFill.style.strokeDashoffset = offset.toFixed(1); }, 100);

    // Animate score counter
    var scoreEl = document.getElementById('ftcpScoreNum');
    var counter = 0;
    var interval = setInterval(function () {
      counter++;
      scoreEl.textContent = counter;
      if (counter >= score) clearInterval(interval);
    }, 60);

    // Level label
    var labelEl = document.getElementById('ftcpLevelLabel');
    var textEl  = document.getElementById('ftcpResultText');
    var dTitle  = document.getElementById('ftcpDetailTitle');
    var dText   = document.getElementById('ftcpDetailText');

    if (level === 'minimal') {
      labelEl.textContent = 'Minimalus poveikis';
      textEl.textContent = 'Jūsų rezultatas rodo, kad skausmas šiuo metu turi minimalų poveikį jūsų kasdieniam gyvenimui. Tai gera žinia — tačiau net ir nedidelis skausmas gali progresuoti, jei yra ignoruojamas.';
      dTitle.textContent = 'Ką rekomenduojame?';
      dText.textContent = 'Palaikykite aktyvų gyvenimo būdą, reguliariai atlikite tempimo ir raumenų stiprinimo pratimus, pasvarstykit prisijungti prie funkcinių-grupinių treniruočių. Jei pastebėsite, kad skausmas dažnėja ar stiprėja, nevėluokite kreiptis — ankstyvoje stadijoje problemos visada būna išsprendžiamos greičiau ir paprasčiau.';
    } else if (level === 'moderate') {
      labelEl.textContent = 'Vidutinis poveikis';
      textEl.textContent = 'Skausmas jau pastebimai riboja kai kurias jūsų veiklas. Tai signalas, kad kūnas siunčia perspėjimą — laikas imtis veiksmų, kol problema nepagilėjo.';
      dTitle.textContent = 'Ką rekomenduojame?';
      dText.textContent = 'Esant vidutiniam poveikiui, profesionali kineziterapeuto konsultacija padėtų nustatyti problemos priežastį ir sudaryti individualų veiksmų planą. Kineziterapija šioje stadijoje duoda puikių rezultatų — daugelis pacientų pajunta reikšmingą pagerėjimą per 4–6 savaites.';
    } else if (level === 'significant') {
      labelEl.textContent = 'Didelis poveikis';
      textEl.textContent = 'Skausmas reikšmingai veikia jūsų gyvenimo kokybę — darbą, miegą, nuotaiką ir kasdienines veiklas. Tai rimtas signalas, kad būtina profesionali pagalba.';
      dTitle.textContent = 'Ką rekomenduojame?';
      dText.textContent = 'Esant dideliam poveikiui, rekomenduojame kuo greičiau kreiptis dėl išsamaus funkcinio įvertinimo. Specialistas nustatys tikslias skausmo priežastis ir sudarys gydymo planą. Kuo anksčiau pradėsite — tuo greičiau atgausite gyvenimo kokybę.';
    } else {
      labelEl.textContent = 'Labai didelis poveikis';
      textEl.textContent = 'Skausmas labai stipriai veikia visas jūsų gyvenimo sritis. Tai rodo, kad organizmas patiria didelį krūvį ir jam reikia profesionalios pagalbos kuo greičiau.';
      dTitle.textContent = 'Ką rekomenduojame?';
      dText.textContent = 'Esant labai dideliam skausmo poveikiui, skubiai rekomenduojame konsultaciją su specializuotu kineziterapeutu ar gydytoju. Specialistas atliks išsamų įvertinimą, nuskausminimo ir reabilitacijos planą. Nesikankinkite vieni — profesionali pagalba gali iš esmės pakeisti jūsų savijautą.';
    }

    // Category breakdown bars
    var breakdown = document.getElementById('ftcpBreakdown');
    var barsHtml = '<h4>Poveikis pagal srit\u012f</h4>';
    cats.forEach(function (cat, i) {
      var val = answers[i + 1] || 0;
      var barPct = (val / 4) * 100;
      barsHtml += '<div class="ftcp-bar-row"><div class="ftcp-bar-label">' + cat.label + '</div><div class="ftcp-bar-track"><span class="ftcp-bar-fill" style="width:' + barPct + '% !important;background-color:' + cat.color + ' !important;background:' + cat.color + ' !important;"></span></div><div class="ftcp-bar-val">' + val + '/4</div></div>';
    });
    breakdown.innerHTML = barsHtml;
  }

  function showStep() {
    var slides = document.querySelectorAll('#ftcpChecker .ftcp-slide');
    slides.forEach(function (s) { s.classList.remove('active'); });

    if (currentStep === 0) {
      document.getElementById('ftcpIntro').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    } else if (currentStep >= 1 && currentStep <= totalSteps) {
      document.getElementById('ftcpQ' + currentStep).classList.add('active');
      progressWrap.style.display = 'block';
      progressFill.style.width = Math.round((currentStep / totalSteps) * 100) + '%';
      stepCount.textContent = currentStep + ' i\u0161 ' + totalSteps + ' klausim\u0173';
      // All questions auto-advance — hide Next
      nav.style.display = currentStep === 1 ? 'none' : 'flex';
      nextBtn.style.display = 'none';
      backBtn.style.visibility = 'visible';
    } else if (currentStep === 7) {
      document.getElementById('ftcpEmail').classList.add('active');
      nav.style.display = 'flex'; progressWrap.style.display = 'block';
      progressFill.style.width = '100%';
      stepCount.textContent = 'Paskutinis \u017eingsnis';
      backBtn.style.visibility = 'visible'; nextBtn.style.display = 'none';
    } else if (currentStep === 8) {
      document.getElementById('ftcpResults').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    }
  }

})();